module.exports = __webpack_public_path__ + "img/img_student3.7a4b30b6.png";